import { periodSearch } from './period/period.search';

/** The Dashboard's period. */
export const dashboardSearch = periodSearch;
